<template>
  <div class="lottery-entry">
    <div class="entry-card">
      <div class="title-pill">Official cooperation upgrade data</div>
      <div class="cert-grid">
        <div class="cert-item">
          <img
            class="cert-icon"
            src="https://ik.imagekit.io/nmil2wj2k/qc.e2d04b23.png?updatedAt=1780093709142"
            alt="Security certification"
          />
          <p>Security<br />certification</p>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            src="https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(7).png?updatedAt=1780093708521"
            alt="Real-name certification"
          />
          <p>Real-name<br />certification</p>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            src="https://ik.imagekit.io/nmil2wj2k/rz.624c9d5f.png?updatedAt=1780093709151"
            alt="Confidentiality certification"
          />
          <p>Confidentiality<br />certification</p>
        </div>
      </div>
    </div>

    <div class="start-btn" @click="enterLottery">
      Start the journey of love
    </div>
  </div>
</template>

<script>
export default {
  name: "LotteryEntry",
  methods: {
    enterLottery() {
      this.$router.push({ path: "/Lottery" });
    },
  },
};
</script>

<style lang="less" scoped>
.lottery-entry {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: url("https://ik.imagekit.io/nmil2wj2k/game-bg.f9413cee.png?updatedAt=1780093709119")
    center top / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.entry-card {
  width: 80%;
  margin-top: 40%;
  padding: 1rem;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}

.title-pill {
  padding: 0.3rem 0.5rem;
  background-color: rgb(247, 59, 165);
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 1rem;
  text-align: center;
}

.cert-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding-top: 1rem;
  font-size: 0.7rem;
}

.cert-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.cert-icon {
  height: 2rem;
  width: auto;
  object-fit: contain;
}

.cert-item p {
  margin: 0;
  padding-top: 0.5rem;
  color: #333;
  line-height: 1.3;
}

.start-btn {
  margin-top: 60px;
  background-color: rgb(247, 59, 165);
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  padding: 20px 48px;
  border-radius: 44px;
  box-shadow: 0 8px 20px rgba(247, 59, 165, 0.4);
  cursor: pointer;
}
</style>
